<template>
	<Popup
		v-model="selfDisplay"
		title="重置密码"
		@confirmClick="handleConfirmClick"
	>
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>账号</span>
				<el-input :value="code" disabled></el-input>
			</div>
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>手机号</span>
				<el-input v-model="my_phone"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="phone_tip"><i class="b_icon"></i>手机号码格式错误</template></div>
		</div>
	</Popup>
</template>

<script>
	import Api from '../../../../../api/index.js';
	
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			oid: {
				type: [Number, String],
				default: ''
			},
			borw: {
				type: String,
				default: '2'
			},
			code: {
				type: String,
				required: true
			},
			phone: {
				type: [Number, String],
				required: true
			}
		},
		data () {
			return {
				selfDisplay: false,
				loading: false,
				my_phone: '',
				phone_tip: false
			}
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		methods: {
			/*********************** @Events *************************/
			// 点击确定按钮
			handleConfirmClick () {
				const that = this;
				if (!that.phoneReg.test(that.my_phone)) {
					that.phone_tip = true;
					return false;
				} else {
					that.phone_tip = false;
				}
				that.$confirm(
					'此操作将以短信通知的方式修改该用户的密码，是否继续?', 
					'提示', 
					{
						type: 'warning'
					}
				).then(
					() => {
						that.reset();
					}
				).catch(
					() => {}
				);
			},
			
			/*********************** @Events *************************/
			// 重置密码
			reset() {
				const that = this;
				that.loading = true;
				var _requestData = {
					borw: that.borw,
					ucode: that.code, 
					updateType: 2,
					type: null,
					phone: that.my_phone,
					uenterpriseId: that.oid
				};
				Api.updatePassword(_requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						this.$emit("success", `${ res.data.message }新密码为：${ res.data.data }`);
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display (newValue) {
				this.selfDisplay = newValue;
			},
			selfDisplay (newValue) {
				this.$emit("changeDisplay", newValue);
				if (newValue) {
					this.loading = false;
					this.my_phone = this.phone;
				}
			}
		}
	}
</script>

<style>
</style>
